// Text s klikacími odkazy. Text píší uživatelé, proto se NIKDY nepoužívá
// dangerouslySetInnerHTML — odkazy se skládají jako React prvky. Regex
// pouští jen http(s):// a www., takže „javascript:" se nikdy nestane odkazem.
const URL_RE = /((?:https?:\/\/|www\.)[^\s<>"')\]]+)/gi;
export function Linkify({ text, className = "" }) {
  const parts = String(text || "").split(URL_RE);
  return (
    <span className={className}>
      {parts.map((p, i) => {
        if (!p) return null;
        if (i % 2 === 0) return <span key={i}>{p}</span>;
        const url = p.replace(/[.,;:!?]+$/, "");        // koncová interpunkce do odkazu nepatří
        const tail = p.slice(url.length);
        const href = url.toLowerCase().startsWith("http") ? url : `https://${url}`;
        return (
          <span key={i}>
            <a href={href} target="_blank" rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
              className="text-brand underline underline-offset-2 hover:opacity-80 break-all">{url}</a>
            {tail}
          </span>
        );
      })}
    </span>
  );
}
